<!--
 * @Author: 裴纬华
 * @Date: 2021-12-27 15:52:32
 * @LastEditors: 裴纬华
 * @LastEditTime: 2021-12-28 15:12:47
 * @Description: 现金流量表
-->
<template>
<div>
      <div :class="[preClass ,'container']">
        <base-table :data="tableData" :headers='headers' ></base-table>
    </div>
</div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      preClass: "income-statement",
      tableData:[],
      headers: ["项目", "本期数",'本年数'],

    };
  },
    computed: {
    ...mapGetters(["currClient", "currDate","currClientDetail"]),
  },
  mounted() {
    this.getData()
  },
  methods: {
       getData() {
      this.$store.commit('app/SET_LOADING_STATUS', true)
      this.tableData = [];
      let params = {
        begin_ym: this.currDate,
        end_ym: this.currDate,
        as_id:this.currClientDetail.as_id
      };
      this.$axios.post("/report/income-statement", params).then(res => {
        console.log('利润表',res)
        if (res.success && res.rows) {
           this.tableData =    res.rows.map(item => {
             return {
                        ...item,
                        title: item.item,
                        value: item.cur_balance,
                        value2: item.total_balance,
                        align: "around",
                        color: "blue",
                        filter: "toThousandFilterNoZero"
                }

          });
        }
      }).finally(_=>{
          this.$store.commit('app/SET_LOADING_STATUS', false)
      });
    },
  }
};
</script>

<style lang='less'>
.income-statement{
  &-title{

  }
}
</style>




// WEBPACK FOOTER //
// src/components/views/financial-report/income-statement/index.vue